
import { Component, Inject, Ref, Vue } from "vue-property-decorator";
import { Container } from "inversify";
// @ts-ignore
import FullCalendar from "@fullcalendar/vue";
import { AuthStore } from "../../../common/src/stores/AuthStore";
import EditEventModal from "../molecules/conference/EditEventModal.vue";
import ViewEventModal from "../molecules/conference/ViewEventModal.vue";
import LoadingOverlay from "../../../common/src/components/LoadingOverlay.vue";
import { handleError } from "../../../common/src/utility/errorUtils";
import UserDashboardMap from "../molecules/user-dashboard/UserDashboardMap.vue";

import * as components from "../molecules/industry-analytics/index";
import NoRecords from "../../../common/src/components/NoRecords.vue";
import { Action } from "@gsx/common";

import SubmitRequestModal from "../../../landing/src/molecules/request-form/SubmitRequestModal.vue";
import SubmitThirdpartyRequestModal from "../../../landing/src/molecules/request-form/SubmitThirdpartyRequestModal.vue";
import Loader from "../molecules/components/Loader.vue";
import TierProgressBar from "../../../common/src/components/TierProgressBar.vue";
import CalendarEvent from "../molecules/user-dashboard/CalendarEvent.vue";
import FavoritedCalendarEvent from "../molecules/user-dashboard/FavoritedCalendarEvent.vue";
import GlobalCalendarEvent from "../molecules/user-dashboard/GlobalCalendarEvent.vue";
import NotificationEvent from "../molecules/user-dashboard/NotificationEvent.vue";
import { FlashNewsListStore } from "../stores/flashNews/FlashNewsListStore";
import SocialFeed from "../molecules/flashNews/SocialFeed.vue";
import { ReportListStore } from "../stores/reports/ReportListStore";
import ReportListItemView from "../molecules/reports/ReportListItem.vue";
import TransactionTable from "../molecules/transactions/TransactionTable.vue";
import { MergerAcquisitionsCollectionStore } from "../stores/mergerAcquisitions/MergerAcquisitionsCollectionStore";
import { MergerAcquisitionsListStore } from "../stores/mergerAcquisitions/MergerAcquisitionsListStore";

@Component({
    components: {
        TierProgressBar,
        SubmitRequestModal,
        SubmitThirdpartyRequestModal,
        NoRecords,
        UserDashboardMap,
        EditEventModal,
        ViewEventModal,
        LoadingOverlay,
        FullCalendar,
        Loader,
        CalendarEvent,
        FavoritedCalendarEvent,
        GlobalCalendarEvent,
        NotificationEvent,
        SocialFeed,
        ReportListItemView,
        TransactionTable,
        ...components,
    },
})
export default class QuiltyUserDashboardView extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);

    Action = Action;

    readonly flashNewsListStore: FlashNewsListStore = this.container.get(FlashNewsListStore);
    readonly reportListStore: ReportListStore = this.container.get(ReportListStore);
    readonly mergerAcquisitionsCollectionStore: MergerAcquisitionsCollectionStore =
        this.container.get(MergerAcquisitionsCollectionStore);

    readonly mergerAcquisitionsListStore: MergerAcquisitionsListStore = this.container.get(
        MergerAcquisitionsListStore,
    );

    @Ref("reportListView")
    readonly reportListViewEle!: HTMLElement;

    @Ref("flashNewsListView")
    readonly flashNewsListViewEle!: HTMLElement;

    created() {
        this.flashNewsListStore.load().catch(handleError);
        this.reportListStore.load().catch(handleError);
        this.mergerAcquisitionsListStore.load().catch(handleError);
    }

    mounted() {
        this.authStore.me();

        if (this.mergerAcquisitionsListStore.organizationId) {
            this.mergerAcquisitionsListStore.clear();
            this.mergerAcquisitionsListStore.organizationId = undefined;
            this.mergerAcquisitionsListStore.reload().catch(handleError);
        }

        this.reportListViewEle.addEventListener("scroll", this.paginateReportListStore);
        this.flashNewsListViewEle.addEventListener("scroll", this.paginateFlashNewsListStore);
    }

    beforeDestroy() {
        this.reportListViewEle.removeEventListener("scroll", this.paginateReportListStore);
        this.flashNewsListViewEle.removeEventListener("scroll", this.paginateFlashNewsListStore);
    }

    paginateReportListStore() {
        if (
            this.reportListViewEle.scrollTop + this.reportListViewEle.clientHeight >=
            this.reportListViewEle.scrollHeight
        ) {
            this.reportListStore.infiniteScroll();
        }
    }

    paginateFlashNewsListStore() {
        if (
            this.flashNewsListViewEle.scrollTop + this.flashNewsListViewEle.clientHeight >=
            this.flashNewsListViewEle.scrollHeight
        ) {
            this.flashNewsListStore.infiniteScroll();
        }
    }
}
